import styled from 'styled-components';

export const SummaryCard = styled.div`
  padding-top: 16px;
  padding-bottom: 16px;
  border-radius: 12px;
  border: 1px solid rgba(230, 230, 230, 1);
  background-color: white;
  display: flex;
  flex-direction: column;
`;

export default SummaryCard;
